import classNames from 'classnames'

import { HTML_LINK_TARGET } from '../../../constants/html'
import { useContentOverflow } from '../../../hooks'
import { stopPropagation } from '../../../utils/events'
import { getWebappLinkPrefix } from '../../../utils/route'
import { FloatingTooltip } from '../../Floating'
import { ICON_COLOR, IconNG } from '../../Icon'
import { Link } from '../../Link'

import * as styles from './EntityLink.module.css'

import LinkIcon from '../../../icons/open-in-new-window.svg'

function EntityLink({
  Icon = LinkIcon,
  className = styles.EntityLink,
  done,
  entity,
  getPreparedEntityLink = getWebappLinkPrefix,
  id,
  target = HTML_LINK_TARGET.blank,
  text,
  to,
  tooltip,
  unread,
  ...restProps
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  const linkClassName = classNames(className, {
    [styles.done]: done,
    [styles.unread]: unread,
  })

  const linkTo = to || getPreparedEntityLink(`${entity.single}/${id}`)

  return (
    <FloatingTooltip content={tooltip || text} disabled={!tooltip && !overflow}>
      <Link
        {...restProps}
        className={linkClassName}
        ref={setContentOverflowRef}
        rel='noreferrer'
        target={target}
        to={linkTo}
        onClick={stopPropagation}
      >
        {text ?? <IconNG Icon={Icon} color={ICON_COLOR.CurrentColor} />}
      </Link>
    </FloatingTooltip>
  )
}

export default EntityLink
